import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonthSelectorComponent } from './month-selector.component';
import { MonthSelectorDropdownComponent } from './month-selector-dropdown.component';

@NgModule({
  declarations: [MonthSelectorComponent, MonthSelectorDropdownComponent],
  imports: [CommonModule],
  exports: [MonthSelectorDropdownComponent]
})
export class MonthSelectorModule {}
